import { IMappingTextPack, IMap } from "@esdm/map";
import { HbsmrUser } from "./HbsmrUser";
import { IVectorLayerGroupConfig } from "@esdm/map/dist/layers/groups/vector/interfaces/IVectorLayerGroupConfig";
import {ColchesterRecordSubType,ColchesterRecordType } from "./ColchesterRecordTypes";
import { IWmsLayerGroupConfig } from "@esdm/map/dist/layers/groups/wms/interfaces";

export class MapBase {

    constructor(
        protected mappingTextPack: IMappingTextPack,
        protected user: HbsmrUser) {
    }

    protected isAuthenticated = (): boolean => {
        return this.user !== null;
    }

    protected filterMapLayers = (layerGroupConfig: Array<IVectorLayerGroupConfig>): Array<IWmsLayerGroupConfig> => {
        //if (!this.isAuthenticated()) {
        //    //remove layers that require authentication
        //    return layerGroupConfig.filter(function (value, index, arr) {
        //        let authlayers = (value.subType === HighlandRecordSubType.Shine || value.type === HighlandRecordType.Consultation);
        //        return !authlayers;
        //    });
        //} else {
        return layerGroupConfig;
        //}
    }
}